import { CampaignContext } from './CampaignContext';

export const CampaignContextProvider = props => {
  return (
    <CampaignContext.Provider value={{ campaign: props.campaign }}>
      {props.children}
    </CampaignContext.Provider>
  );
};
